import { Sun, Moon } from 'lucide-react';

/**
 * Theme Switcher - Toggle between light and dark themes
 *
 * Visual toggle with smooth transitions
 */
export default function ThemeSwitcher({ theme, onToggle }) {
  const isDark = theme === 'dark';

  return (
    <button
      onClick={onToggle}
      className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all ${
        isDark
          ? 'bg-gray-700 text-yellow-400 hover:bg-gray-600'
          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
      }`}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      {isDark ? <Moon size={18} /> : <Sun size={18} />}
      <span className="text-sm">
        {isDark ? 'Dark' : 'Light'}
      </span>
    </button>
  );
}
